type ProgressBarProps = {
  progress: number;
  color?: string;
};
export default function ProgressBar({ progress,color }: ProgressBarProps) {
  return (
    <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden shadow-md">
      <div
        className={`bg-blue-500 h-3 flex items-center pl-5 text-[10px] text-white text-center transition-all duration-300 font-semibold bg-${color}`}
        style={{ width: `${progress}%` }}
      >
        
      </div>
    </div>
  );
}
